import { AppDispatch, RootState } from '..';
import { addCompany, addCompanyLoading, getCompany, getCompanyExistance, isLoadingCompany, onUpdatingCompany } from '../reducers';
import { getUser, headers, updateUserCompanyId } from '.';

import { REACT_APP_COMPANY_SERVICE_ENDPOINT } from '../types';
import { addCompanyAction } from '../../types';
import axios from 'axios';
import { notification } from '../../utils';

export const companyExistance = () => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;
    const { user } = getState().userReducer;

    return axios
        .get(`${REACT_APP_COMPANY_SERVICE_ENDPOINT}/company/check/${user?.email}`, {
            headers: {
                authorization: `Bearer ${token}`,
            }
        })
        .then(res => {

            const { company } = res.data;
            dispatch(getCompanyExistance(company));
        })
        .catch(err => {
            console.log(`Company existance error: ${err}`);
        });

};

export const fetchCompany = () => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(isLoadingCompany(true));

    const { token } = getState().authReducer;
    const { user } = getState().userReducer;

    const { data } = await axios.get(`${REACT_APP_COMPANY_SERVICE_ENDPOINT}/company/${user?.company_id}`, headers(token));

    const { company } = data;

    try {

        dispatch(getCompany(company));
        dispatch(isLoadingCompany(false));

    } catch (error: any) {

        console.log(error.message);
        dispatch(isLoadingCompany(false));

    }

};

export const registerCompany = (values: addCompanyAction) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    dispatch(addCompanyLoading(true));

    const { data } = await axios.post(`${REACT_APP_COMPANY_SERVICE_ENDPOINT}/company/add`, { ...values }, headers(token));

    const { success, message, company } = data;

    try {

        dispatch(addCompany({ success, message, company }));
        dispatch(addCompanyLoading(false));
        dispatch(companyExistance());
        notification(success ? 'success' : 'error', message);
        dispatch(updateUserCompanyId(company?.company_id)).then(() => dispatch(getUser()));

    } catch (error: any) {

        console.log(error.message);
        dispatch(addCompanyLoading(false));
        notification('error', message);

    }

};

export const updateCompany = (id: string, values: addCompanyAction) => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onUpdatingCompany(true));

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_COMPANY_SERVICE_ENDPOINT}/company/${id}/update`, { ...values }, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(onUpdatingCompany(false));

    } catch (error: any) {

        notification(success ? 'success' : 'error', message || error.message);
        dispatch(onUpdatingCompany(false));

    }
};

export const uploadLogo = (formData: any) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;
    const { company } = getState().companyReducer;

    const { company_id } = company;

    const { data } = await axios({
        method: 'post',
        url: `${REACT_APP_COMPANY_SERVICE_ENDPOINT}/company/${company_id}/upload-logo`,
        data: formData,
        headers: {
            authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
        }
    });

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchCompany());

    } catch (error: any) {

        notification(success ? 'success' : 'error', message || error.message);
        console.log(error.message);

    }
};

export const updateCompanyTermsAndConditions = (values: { company_id: string; terms_and_conditions: string | null; }) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_COMPANY_SERVICE_ENDPOINT}/company/website/update-terms-and-conditions`, { ...values }, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchCompany());

    } catch (error: any) {

        notification('error', message);
        console.error(error.message);

    }
};

export const updateVatOption = (values: { company_id: string; vat: boolean; }) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_COMPANY_SERVICE_ENDPOINT}/company/update-vat-option`, { ...values }, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchCompany());

    } catch (error: any) {

        notification('error', message);
        console.error(error.message);

    }
}; 

export const updateReferalRate = (values: { company_id: string; referal_rate: number; }) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_COMPANY_SERVICE_ENDPOINT}/company/update-referal-rate`, { ...values }, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchCompany());

    } catch (error: any) {

        notification('error', message);
        console.error(error.message);

    }
}; 

export const updateDiscountRate = (values: { company_id: string; discount_percentage: number; }) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;
    values!.discount_percentage = values.discount_percentage/100;
    const { data } = await axios.put(`${REACT_APP_COMPANY_SERVICE_ENDPOINT}/company/update-discount-percentage`, { ...values }, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchCompany());

    } catch (error: any) {

        notification('error', message);
        console.error(error.message);

    }
}; 

export const updateCompanyRegNumber = (values: { company_id: string; company_reg_number: string; }) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_COMPANY_SERVICE_ENDPOINT}/company/update-company-reg-number`, { ...values }, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchCompany());

    } catch (error: any) {

        notification('error', message);
        console.error(error.message);

    }
}; 

export const updateBetaTester = (values: { company_id: string; is_beta_tester: boolean; }) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_COMPANY_SERVICE_ENDPOINT}/company/beta-tester`, { ...values }, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchCompany());

    } catch (error: any) {

        notification('error', message);
        console.error(error.message);

    }
}; 